export default "__VITE_PUBLIC_ASSET__b977c9cd__"